let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("glWzP"), load("3XYal"), load("1Ojgx")]).then(() => parcelRequire('4E1b5'));